import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { profile } from "@/data/portfolio";

const CTA = () => (
    <section id="contact" data-testid="cta-section" className="relative py-12 sm:py-16">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <div
                    data-testid="cta-card"
                    className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-ink-2 px-6 py-20 text-center sm:px-12 sm:py-28"
                >
                    <div className="bg-grid mask-cta absolute inset-0" aria-hidden="true" />
                    <div
                        className="pointer-events-none absolute left-1/2 top-1/2 h-[380px] w-[620px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-flame/[0.13] blur-[120px]"
                        aria-hidden="true"
                    />
                    <div
                        className="pointer-events-none absolute inset-x-12 top-0 h-px bg-gradient-to-r from-transparent via-flame/60 to-transparent"
                        aria-hidden="true"
                    />

                    <div className="relative">
                        <p className="font-display text-2xl font-medium text-slate-300 sm:text-3xl">
                            Have an idea?
                        </p>
                        <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-slate-50 sm:text-6xl">
                            Let's{" "}
                            <em className="font-serifit text-[1.06em] font-medium italic text-[#f6e3d3]">
                                work
                            </em>{" "}
                            together
                        </h2>
                        <p className="mx-auto mt-6 max-w-md text-base leading-relaxed text-slate-400">
                            Have a video project in mind? Let's turn your idea into something
                            engaging.
                        </p>
                        <a
                            data-testid="cta-button"
                            href={`mailto:${profile.email}`}
                            className="group mt-10 inline-flex items-center gap-2 rounded-full bg-flame px-8 py-4 text-sm font-semibold text-white shadow-[0_0_50px_rgba(255,75,38,0.35)] transition-[background-color,box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:bg-flame-hover hover:shadow-[0_0_70px_rgba(255,75,38,0.55)]"
                        >
                            Let's work together
                            <ArrowUpRight
                                size={16}
                                className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                            />
                        </a>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);

export default CTA;
